import { produce } from 'immer';

import { APP_KEYS_ACTION_TYPE } from '../actions/appKeys.actions';

const initialState = {
  data: {},
  loading: false,
  error: null,
};

const appKeysReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case APP_KEYS_ACTION_TYPE.GET_APP_KEYS_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;

      case APP_KEYS_ACTION_TYPE.GET_APP_KEYS_SUCCESS:
        draft.data = payload || {};
        draft.loading = false;
        draft.error = null;
        break;

      case APP_KEYS_ACTION_TYPE.GET_APP_KEYS_FAILURE:
        draft.loading = false;
        draft.error = payload;
        break;

      case APP_KEYS_ACTION_TYPE.GET_APP_KEY:
      case APP_KEYS_ACTION_TYPE.CREATE_APP_KEY:
      case APP_KEYS_ACTION_TYPE.UPDATE_APP_KEY:
      case APP_KEYS_ACTION_TYPE.TOGGLE_APP_KEY_ACTIVE:
        // Merge the updated app key data
        if (payload) {
          Object.keys(payload).forEach(id => {
            draft.data[id] = payload[id];
          });
        }

        break;

      case APP_KEYS_ACTION_TYPE.DELETE_APP_KEY:
        delete draft.data[meta.id];
        break;

      default:
        return state;
    }
  });

export default appKeysReducer;
